import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconText = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "title_24dp_FILL0_wght400_GRAD0_opsz24 2",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M9.2474 16.6654V5.83203H4.66406V3.33203H16.3307V5.83203H11.7474V16.6654H9.2474Z",
			fill: "currentColor"
		})
	})
});
export default SvgIconText;
